import { SurveyOption } from '../../SimpleSurvey/types';

export const surveyOptions: SurveyOption[] = [
  {
    id: 'influencer',
    label: 'Influencer',
  },
  {
    id: 'acquaintances',
    label: 'Friend or colleague',
  },
  {
    id: 'kittl-socials',
    label: 'Kittl Socials',
  },
  {
    id: 'ads',
    label: 'Ads',
  },
  {
    id: 'search',
    label: 'Search Engine (Eg. Google)',
  },
  {
    id: 'other',
    label: 'Other',
  },
];
